export const selectCaptureActivityEvents = (state) =>
  state.capture.activity.events;

export const selectCaptureActivityIsLoading = (state) =>
  state.capture.activity.isLoading;

export const selectCaptureActivityError = (state) =>
  state.capture.activity.error;

export const selectCaptureActivitySearch = (state) =>
  state.capture.activity.search;

export const selectCaptureActivityIsLoadingMore = (state) =>
  state.capture.activity.isLoadingMore;

export const selectCaptureActivitySort = (state) => state.capture.activity.sort;

export const selectCaptureActivityHasMore = (state) =>
  state.capture.activity.hasMore;

export const selectCaptureActivityTotal = (state) =>
  state.capture.activity.total;

export const selectCaptureActivityFilteredTotal = (state) =>
  state.capture.activity.filteredTotal;
